// MultiSelect.tsx
import React, { useEffect, useRef, useState } from "react";
import "./multiselect.scss";
import Input from "antd/lib/input";
import { Checkbox } from "antd";
import classNames from "classnames";
import { find, head } from "lodash";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

interface Option {
  id: any;
  label: string;
}

const MultiSelect = ({ options, handleSelect, value, titleHeader }: { options: Option[]; handleSelect: any; value: any[]; titleHeader?: any }) => {
  // const [selectedOptions, setSelectedOptions] = useState<any[]>([...value]);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const buttonRef: any = useRef(null);
  const dropdownRef: any = useRef(null);

  // individual option check uncheck handler
  const toggleOption = (id: any): void => {
    handleSelect(value.includes(id) ? value.filter((optionId) => optionId !== id) : [...value, id]);
  };

  // outside click handler
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // handle Select All Functionality
  const handleSelectAll = (): void => {
    if (value.length === options.length) {
      handleSelect([]);
    } else {
      handleSelect(options.map((option) => option.id));
    }
  };

  const isOptionSelected = (id: any): boolean => value?.includes(id);

  const filteredOptions = options.filter((option) => option.label.toLowerCase().includes(searchTerm.toLowerCase()));

  const className = classNames("multiselect-dropdown", {
    focused: showDropdown,
  });

  return (
    <div className="multiselect-container">
      {/* <div className={"multiselect-dropdown-count"}>{ titleHeader }</div> */}
      <div ref={buttonRef} className={className} onClick={() => setShowDropdown(!showDropdown)}>
        <div className={"multiselect-dropdown-title"}>{value.length > 0 ? `${find(options, { id: head(value) })?.label}` : `Select ${titleHeader}` || "Select options"}</div>
        <div className={"multiselect-dropdown-count"}>{value.length > 1 ? ` ( +${value.length - 1} )` : ""}</div>
        <span className="arrow-down">{showDropdown ? <DownOutlined /> : <UpOutlined />}</span>
      </div>
      {showDropdown && (
        <div ref={dropdownRef} className="multiselect-options">
          <div className="multiselect-search">
            <Input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
          </div>
          <div className="multiselect-option">
            <Checkbox checked={value.length === options.length} onChange={handleSelectAll}>
              Select all {titleHeader}
            </Checkbox>
          </div>
          {filteredOptions.map((option) => (
            <div key={option.id} className="multiselect-option">
              <Checkbox checked={isOptionSelected(option.id)} onChange={() => toggleOption(option.id)}>
                {option.label}
              </Checkbox>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelect;

export const MultiSelectOpen = ({ options, handleSelect, value, titleHeader, isSearchRequired = true }: { options: Option[]; handleSelect: any; value: any[]; titleHeader?: any, isSearchRequired?: boolean }) => {
  // const [selectedOptions, setSelectedOptions] = useState<any[]>([...value]);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const buttonRef: any = useRef(null);
  const dropdownRef: any = useRef(null);

  // individual option check uncheck handler
  const toggleOption = (id: any): void => {
    handleSelect(value.includes(id) ? value.filter((optionId) => optionId !== id) : [...value, id]);
  };

  // outside click handler
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // handle Select All Functionality
  const handleSelectAll = (): void => {
    if (value.length === options.length) {
      handleSelect([]);
    } else {
      handleSelect(options.map((option) => option.id));
    }
  };

  const isOptionSelected = (id: any): boolean => value?.includes(id);

  const filteredOptions = options.filter((option) => option.label.toLowerCase().includes(searchTerm.toLowerCase()));

  const className = classNames("multiselect-dropdown", {
    focused: showDropdown,
  });

  return (
    <div className="multiselect-container">
      {/* <div className={"multiselect-dropdown-count"}>{ titleHeader }</div> */}
      {/* <div ref={buttonRef} className={className} onClick={() => setShowDropdown(!showDropdown)}>
        <div className={"multiselect-dropdown-title"}>
          { value.length > 0
            ? `${find(options, { id: head(value) })?.label}`
            : `Select ${titleHeader}` || "Select options"}
        </div>
        <div className={"multiselect-dropdown-count"}>
          {value.length > 1
            ? ` ( +${value.length - 1} )`
            : ""
          }
        </div>
        <span className="arrow-down">{showDropdown ? <DownOutlined /> : <UpOutlined />}</span>
      </div> */}

      {/* {showDropdown && ( */}
      {isSearchRequired && (
        <div className="multiselect-search">
          <Input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        </div>
      )}
      <div ref={dropdownRef} className="multiselect-options">
        <div className="multiselect-option">
          <Checkbox checked={value.length === options.length} onChange={handleSelectAll}>
            Select all {titleHeader}
          </Checkbox>
        </div>
        {filteredOptions.map((option) => (
          <div key={option.id} className="multiselect-option">
            <Checkbox checked={isOptionSelected(option.id)} onChange={() => toggleOption(option.id)}>
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      {/* )} */}
    </div>
  );
};
